module.exports = __webpack_public_path__ + "img/casein-1.755bae25.png";